import state from './state'
import getters from './getters'
import mutations from './mutations'
import actions from './action'

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/view/login/state/index.js